import React, { useState } from "react";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import APIS from "../../../constant/Endpoint";
import NACell from "../../Reusable/DataTable/NACell";
import DataTable from "../../Reusable/DataTable";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Button from "../../Reusable/Button";
import CreateContactModal from "../CreateContacts/CreateContactModal";
import UpdateContactModal from "../CreateContacts/UpdateContact/UpdateContactModal";
import EditIcon from "../../../Icons/EditIcon";
import { DeleteIcon } from "../../../Icons/DeleteIcon/DeleteIcon";
import DeleteContact from "../CreateContacts/DeleteContact/DeleteContact";

interface ContactTableProps {
  selectedGroupId: any;
  handleIsActive?: any;
  handleIsEnableEmail?: any;
  handleIsEnableSMS?: any;
}

const ContactTable: React.FC<ContactTableProps> = ({
  selectedGroupId,
  handleIsActive,
  handleIsEnableEmail,
  handleIsEnableSMS,
}) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // New state for delete modal
  const [selectedContactId, setSelectedContactId] = useState<string | null>(
    null
  );

  // Handler for opening the update modal
  const handleEdit = (id: string) => {
    setSelectedContactId(id);
    setShowUpdateModal(true);
  };

  // Handler for opening the delete modal
  const handleDelete = (id: string) => {
    setSelectedContactId(id);
    setShowDeleteModal(true);
  };

  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },
    {
      header: "Phone",
      accessorKey: "phone_number",
      cell: NACell,
    },
    {
      header: "DOB",
      accessorKey: "dob",
      cell: ({ getValue }: any) => (
        <p className={tw` whitespace-nowrap`}>{getValue() ?? "N/A"}</p>
      ),
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row }: any) => {
        const id = row.original.id;
        return (
          <AccessControl allowedPermissions={["can_update_setting"]}>
            <div className={tw`flex gap-2`}>
              <Button
                label={
                  <span className={tw`text-white text-xl`}>
                    <EditIcon />
                  </span>
                }
                size="sm"
                onClick={() => handleEdit(id)}
                className={tw`w-6 focus:outline-none`}
              />
              <Button
                label={
                  <span className={tw`text-white text-lg`}>
                    {" "}
                    <DeleteIcon />
                  </span>
                }
                size="sm"
                onClick={() => handleDelete(id)}
                className={tw`w-5 focus:outline-none`}
              />
            </div>
          </AccessControl>
        );
      },
    },
  ];

  return (
    <div className={tw`w-[80%] ml-auto mr-0`}>
      <div className={tw`mb-4 flex justify-end w-[90px]`}>
        <Button label="Add Contact" onClick={() => setShowCreateModal(true)} />
      </div>

      <DataTable
        url={APIS.CONTACT}
        queryKey={"contacts"}
        params={{
          ...(selectedGroupId?.is_default
            ? {
                group: null,
              }
            : { group: selectedGroupId?.id }),
        }}
        columns={defaultColumns}
        tableName={"Contact"}
      />

      <CreateContactModal
        isOpen={showCreateModal}
        setIsOpen={setShowCreateModal}
      />

      {selectedContactId && (
        <>
          <UpdateContactModal
            isOpen={showUpdateModal}
            setIsOpen={(val: boolean) => {
              setShowUpdateModal(val);
              if (!val) setSelectedContactId(null);
            }}
            id={selectedContactId}
          />
          <DeleteContact
            isOpen={showDeleteModal}
            setIsOpen={setShowDeleteModal}
            groupId={selectedContactId}
            onConfirm={() => {
              setShowDeleteModal(false);
              setSelectedContactId(null);
            }}
          />
        </>
      )}
    </div>
  );
};

export default ContactTable;
